import { Link, useLocation, useNavigate } from "react-router-dom";
import { Phone, Mail, FileUp } from "lucide-react";
import { useSite } from "../context/SiteContext";

export default function MobileBar() {
  const site = useSite();
  const location = useLocation();
  const navigate = useNavigate();
  if (location.pathname.startsWith("/admin")) return null;

  const goPlans = () => {
    if (location.pathname === "/contact") {
      document.getElementById("upload")?.scrollIntoView({ behavior: "smooth", block: "center" });
    } else {
      navigate("/contact#upload");
    }
  };

  return (
    <div data-testid="mobile-contact-bar" className="md:hidden fixed bottom-0 inset-x-0 z-50 bg-ink border-t border-white/10 grid grid-cols-3">
      <a href={`tel:${site.phone}`} data-testid="mobilebar-call" className="flex flex-col items-center justify-center gap-1 py-3 text-white active:bg-white/10">
        <Phone className="w-4 h-4 text-gold" />
        <span className="font-mono text-[10px] tracking-[0.2em] uppercase">Call</span>
      </a>
      <a href={`mailto:${site.email}`} data-testid="mobilebar-email" className="flex flex-col items-center justify-center gap-1 py-3 text-white border-x border-white/10 active:bg-white/10">
        <Mail className="w-4 h-4 text-gold" />
        <span className="font-mono text-[10px] tracking-[0.2em] uppercase">Email</span>
      </a>
      <button onClick={goPlans} data-testid="mobilebar-send-plans" className="flex flex-col items-center justify-center gap-1 py-3 bg-gold text-white active:bg-golddark">
        <FileUp className="w-4 h-4" />
        <span className="font-mono text-[10px] tracking-[0.2em] uppercase">Send Plans</span>
      </button>
    </div>
  );
}
